"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconTileContainerStyle = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const IconTileContainerStyle = _styledComponents.default.div.withConfig({
  displayName: "Tilestyles__IconTileContainerStyle",
  componentId: "sc-2f2ber-0"
})(["position:relative;display:flex;flex-direction:column;box-sizing:border-box;justify-content:center;align-items:center;text-align:center;cursor:pointer;width:98px;padding:0 20px;margin-top:10px;margin-bottom:10px;", ";", ";.label{margin-top:5px;cursor:pointer;", ";white-space:break-spaces;color:", ";}.remove{", ";color:", ";margin-top:8px;}"], ({
  isDragging
}) => isDragging && `border: 2px dashed ${_shared.theme.palette.ui.cta.blue}; background: ${_shared.theme.palette.brand.primary.white}`, ({
  isDragging
}) => isDragging && _shared.theme.shadows.light.level3, ({
  capitalize
}) => capitalize ? _shared.theme.typography.kicker : _shared.theme.typography.h6, _shared.theme.palette.brand.primary.charcoal, _shared.theme.typography.h6, _shared.theme.palette.ui.cta.blue);

exports.IconTileContainerStyle = IconTileContainerStyle;